import { useContext, useEffect, useState } from "react";

import MapContext from "../map/MapContext";

import olTileLayer from "ol/layer/Tile";
import olMap from "ol/Map";
import olTileSource from "ol/source/Tile";
import olLayer from "ol/layer/Layer";

type Props = {
  source: olTileSource;
  visible?: boolean;
};

/**
 * Component to register a new OL Tile Layer on the Map
 * using the MapContext.
 * @component
 * @param {import("ol/source/Tile").default} source The OL source to use
 * @example
 * <Tile source={osmSource} />
 */
const Tile = ({ source, visible = true }: Props) => {
  const map = useContext(MapContext) as olMap;
  const [layer, setLayer] = useState<olLayer | null>(null);

  useEffect(() => {
    if (!map) return () => {};

    const layer = new olTileLayer({
      source,
      visible,
      zIndex: 0,
    });

    map.addLayer(layer);

    setLayer(layer);
    return () => {
      if (!map) return;
      map.removeLayer(layer);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map]);

  useEffect(() => {
    if (!layer) return;
    layer.setSource(source);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [source]);

  useEffect(() => {
    if (!layer) return;
    layer.setVisible(visible);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  return null;
};

export default Tile;
